import axios from 'axios'
import store from "../store/store.js"

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.get['Content-Type'] = 'application/json';
let url=store.state.commonip
const server = axios.create({
  baseURL: url,
  timeout: 50000,

})
server.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.inject("操作错误")
  }
)
server.interceptors.response.use(
  config => {
    return config
  },
  err => {
    return Promise.inject("操作错误")
  }
)

export function post(url, pramas, type) {
  return server.post(url, pramas, type)
}

export function get(url, pramas, type) {
  return server.get(url, pramas, type)
}

export default server



// WEBPACK FOOTER //
// ./src/api/index.js